const diaSemanas = [
  { value: 1, label: 'Segunda' },
  { value: 2, label: 'Terca' }, // Removed special character
  { value: 3, label: 'Quarta' },
  { value: 4, label: 'Quinta' },
  { value: 5, label: 'Sexta' }
]

// Metodo para buscar o label pelo valor
function getLabelByValue(value: number) {
  const dia = diaSemanas.find(d => d.value === value)
  return dia ? dia.label : 'Valor invalido' // Removed special character
}

/**
 * Extracts the numeric id from a field that may be:
 *   - a number: 1000
 *   - a flat string from backend: "CD Barueri" (no id prefix)
 *   - a concatenated string from local card: "1000 CD Barueri" or "1000 - CD Barueri"
 *   - an object with id/codigo/value
 */
const extractId = (field: any): string => {
  if (!field && field !== 0) return ''
  if (typeof field === 'number') return String(field)
  if (typeof field === 'string') {
    const match = field.match(/^(\d+)/)
    return match ? match[1] : ''
  }
  return String(field.id ?? field.codigo ?? field.value ?? '')
}

/**
 * Extracts the display name from a field that may be:
 *   - a plain name string from backend: "CD Barueri"
 *   - a concatenated string from local card: "1000 CD Barueri" or "1000 - CD Barueri"
 *   - an object with nome/descricao/label
 */
const extractNome = (field: any): string => {
  if (!field && field !== 0) return ''
  if (typeof field === 'number') return String(field)
  if (typeof field === 'string') {
    // Remove leading numeric id and optional separator ("1000 " or "1000 - ")
    return field.replace(/^\d+\s*[-–]?\s*/, '').trim()
  }
  return String(field.nome ?? field.descricao ?? field.label ?? '')
}

// compradorEmail: e-mail do comprador dono do cronograma na tela; usado quando o
// item não traz o próprio (cards novos). Nunca usa o e-mail de quem exporta.
export const parseParametrizationPurchaseCronogramaExport = (
  data: any[],
  compradorEmail = ''
): any[] => {
  if (!Array.isArray(data)) {
    return []
  }
  const res = []
  for (const item of data) {
    if (item) {
      // empresaId is always a plain number — no normalization needed
      const empresaCodigo = item.empresaId ? String(item.empresaId) : ''

      // lojaId / lojaNome: backend sends flat primitives; local cards may
      // send lojaNome as "1000 CD Barueri" or "1000 - CD Barueri"
      const centroCodigo = item.lojaId
        ? String(item.lojaId)
        : extractId(item.lojaNome)
      const centroNome = extractNome(item.lojaNome)

      // fornecedorId / fornecedorNome: local cards build the label as
      // "${fornecedorId} - ${fornecedorNome}"
      const fornecedorCodigo = item.fornecedorId
        ? String(item.fornecedorId)
        : extractId(item.fornecedorNome)
      const fornecedorNome = extractNome(item.fornecedorNome)

      // categoriaCompactaId / categoriaCompactaNome: local cards build the
      // label as "${categoriaCompactaId} - ${categoriaCompactaNome}"
      const categoriaCodigo = item.categoriaCompactaId
        ? String(item.categoriaCompactaId)
        : extractId(item.categoriaCompactaNome)
      const categoriaNome = extractNome(item.categoriaCompactaNome)

      res.push({
        'Empresa - Codigo': empresaCodigo,
        'Centro - Nome': centroNome,
        'Centro - Codigo': centroCodigo,
        'Fornecedor - Nome': fornecedorNome,
        'Fornecedor - Codigo': fornecedorCodigo,
        'CategoriaCompacta - Nome': categoriaNome,
        'CategoriaCompacta - Codigo': categoriaCodigo,
        'Dia - Semana': getLabelByValue(item.diaDaSemana) || '',
        'Usuario - Email': item.usuarioEmail || compradorEmail || ''
      })
    }
  }

  return res
}
